import axios from 'axios';
import { Api, Url, Crypto, SessionCache } from '@/utils/';

export default class Contacts {
    static get() {
        let constructed_url = Url.get("contacts") + Url.getAccountParam();
        const promise = new Promise((resolve, reject) => {
            let contacts = [];

            if (!SessionCache.hasContacts()) {
                queryContacts(300, 3000, 0);
            } else {
                resolve(SessionCache.getContacts());
            }

            function queryContacts(pageLimit, totalLimit, afterId) {
                axios.get(constructed_url + "&limit=" + pageLimit + "&offset=" + contacts.length + "&after_id=" + afterId).then(response => {
                    response = response.data;

                    // Track the highest id so the cursor moves forward even if decryption fails.
                    let maxId = afterId;
                    for (let i = 0; i < response.length; i++) {
                        const item = response[i];
                        if (item.id > maxId) {
                            maxId = item.id;
                        }

                        const contact = Crypto.decryptContact(item);
                        if (contact != null)
                            contacts.push(contact);
                    }

                    if (response.length == pageLimit/* && contacts.length < totalLimit*/) {
                        queryContacts(pageLimit, totalLimit, maxId);
                    } else {
                        finishQuery(contacts);
                    }
                }).catch(response => Api.rejectHandler(response, reject));
            }

            function finishQuery(contacts) {
                contacts.sort(function (a, b) {
                    let nameA = a.name.toUpperCase();
                    let nameB = b.name.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                SessionCache.putContacts(contacts);
                resolve(contacts);
            }
        });

        return promise;
    }

    static delete (id) {
        const constructedURL = Url.get('remove_contact') + id + Url.getAccountParam();
        const promise = new Promise((resolve, reject) => {
            axios.post(constructedURL)
                .then(response => resolve(response))
                .catch(response => Api.rejectHandler(response, reject));
        });
        return promise;
    }
}
